var generic = generic || {};
var site = site || {};

(function ($) {
  Drupal.behaviors.emailSignupFormCustomInputTelV1 = {
    attach: function (context) {}
  };
})(jQuery);
